var de = Object.defineProperty, ce = Object.defineProperties;
var ue = Object.getOwnPropertyDescriptors;
var R = Object.getOwnPropertySymbols;
var pe = Object.prototype.hasOwnProperty, ge = Object.prototype.propertyIsEnumerable;
var A = (g, d, a) => d in g ? de(g, d, { enumerable: !0, configurable: !0, writable: !0, value: a }) : g[d] = a, I = (g, d) => {
  for (var a in d || (d = {}))
    pe.call(d, a) && A(g, a, d[a]);
  if (R)
    for (var a of R(d))
      ge.call(d, a) && A(g, a, d[a]);
  return g;
}, K = (g, d) => ce(g, ue(d));
var v = (g, d, a) => new Promise((U, b) => {
  var y = (u) => {
    try {
      h(a.next(u));
    } catch (r) {
      b(r);
    }
  }, x = (u) => {
    try {
      h(a.throw(u));
    } catch (r) {
      b(r);
    }
  }, h = (u) => u.done ? U(u.value) : Promise.resolve(u.value).then(y, x);
  h((a = a.apply(g, d)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { reqGetCurrentUser as T } from "@oppein/op-utils";
import fe from "./components/userSelectedByCoditionDialog.ce.vue.js";
import { getGetOrganizationalStructureTreeToMTDSByOrgType as we } from "../../request/ucenterapi/uc/internal/department/getOrganizationalStructureTreeToMTDSByOrgType/get.js";
import { postLogin as me } from "../../request/ucenterapi/oauth/mobile/login/post.js";
import ye from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tree/src/Tree.js";
import $ from "../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneDeep.js";
import { defineComponent as xe, useTemplateRef as he, computed as ve, openBlock as _, createElementBlock as E, createElementVNode as n, createVNode as i, withCtx as w, createTextVNode as k, Fragment as V, createCommentVNode as M, h as N } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as ke } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as C, reactive as j, unref as c } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import be from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ne from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import m from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import { toDisplayString as F } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import q from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import Ce from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Ue = { class: "tw:flex tw:items-center tw:w-full tw:gap-5 tw:flex-wrap" }, Se = { class: "tw:flex tw:items-center tw:gap-2.5 tw:flex-wrap" }, Oe = { class: "tw:flex tw:gap-3" }, De = { class: "tw:min-w-[200px] tw:max-w-[260px] tw:overflow-y-auto tw:h-[500px] tw:pr-3 tw:border-0 tw:border-r tw:border-gray-200 tw:border-solid" }, Ie = { class: "tw:min-w-0 tw:flex-1" }, Te = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-3" }, _e = { class: "tw:mb-2" }, Ee = { class: "tw:text-[#4378ff] tw:font-semibold tw:px-1" }, Pe = {
  key: 0,
  class: "tw:min-w-0 tw:flex-1"
}, Le = { class: "tw:mb-2" }, Be = { class: "tw:text-[#4378ff] tw:font-semibold tw:px-1" }, ze = { class: "tw:flex tw:justify-end tw:gap-2" }, tt = /* @__PURE__ */ xe({
  name: "UserSelectedDialog",
  __name: "userSelectedDialog.ce",
  emits: ["submit"],
  setup(g, { expose: d, emit: a }) {
    const U = a, b = he("userSelectedDialogContainer"), y = ke(), x = C(!1), h = C(!1), u = C({
      name: "",
      account: "",
      orgNo: ""
    }), r = j({
      isLoading: !1,
      selectedUser: [],
      selectedOrg: [],
      treeData: [],
      defaultExpandedKeys: []
    }), l = j({
      isExpanded: !1,
      // 是否展开切换表单
      isChangeSuccess: !1,
      // 是否切换成功
      orgNo: "",
      adminPassword: "",
      loading: !1
    }), H = ve(() => r.selectedOrg.map((t) => t.orgId)), J = (t) => t.businessType === "department", Q = ({ option: t }) => N("span", { class: "tw:inline-flex tw:items-center" }, [
      N("span", null, t.name),
      N(
        "span",
        {
          class: "tw:text-[#4378ff] tw:text-base tw:pl-1 tw:cursor-pointer tw:select-none",
          title: "选择人员",
          onClick: (e) => {
            e.stopPropagation(), Z(t);
          }
        },
        "⊕"
      )
    ]), W = [
      {
        title: "序号",
        key: "index",
        width: 70,
        align: "center",
        render: (t, e) => e + 1
      },
      { title: "用户名称", key: "userName", align: "center", ellipsis: { tooltip: !0 } },
      { title: "用户ID", key: "userId", align: "center", ellipsis: { tooltip: !0 } },
      {
        title: "操作",
        key: "action",
        width: 100,
        align: "center",
        render: (t) => N(
          m,
          {
            type: "primary",
            text: !0,
            onClick: () => ee(t.userId)
          },
          { default: () => "删除" }
        )
      }
    ], X = [
      {
        title: "序号",
        key: "index",
        width: 70,
        align: "center",
        render: (t, e) => e + 1
      },
      { title: "组织名称", key: "orgName", align: "center", ellipsis: { tooltip: !0 } },
      { title: "组织ID", key: "orgId", align: "center", ellipsis: { tooltip: !0 } },
      {
        title: "操作",
        key: "action",
        width: 100,
        align: "center",
        render: (t) => N(
          m,
          {
            type: "primary",
            text: !0,
            onClick: () => te(t.orgId)
          },
          { default: () => "删除" }
        )
      }
    ], G = (t, e) => {
      for (const s of t) {
        if (s.id === e)
          return s;
        if (s.children && s.children.length) {
          const o = G(s.children, e);
          if (o)
            return o;
        }
      }
    }, Y = (t, e = "superiorId", s = "id") => {
      if (!t)
        return [];
      const o = [], p = {};
      return t.forEach((f) => {
        f.children || (f.children = []), p[f[s]] = f;
      }), t.forEach((f) => {
        const O = p[f[e]];
        O ? O.children.push(f) : o.push(f);
      }), o;
    }, L = (t) => v(this, null, function* () {
      var e, s;
      try {
        r.isLoading = !0;
        let o = t;
        o || (o = (yield T()).orgNo);
        const p = yield we({
          orgType: o !== "OPPEIN.COM" ? "AGENT" : "OPPEIN",
          orgNo: o
        });
        if (!p)
          return;
        const f = ((e = p.positionList) == null ? void 0 : e.map((D) => K(I({}, D), { businessType: "position" }))) || [], O = ((s = p.departmentList) == null ? void 0 : s.map((D) => K(I({}, D), { businessType: "department" }))) || [];
        r.treeData = Y([...f, ...O]), r.treeData.length > 0 && (r.defaultExpandedKeys = [r.treeData[0].id]);
      } catch (o) {
        console.error(o);
      } finally {
        r.isLoading = !1;
      }
    }), B = C(null), Z = (t) => v(this, null, function* () {
      var p;
      const e = {}, s = String(t.type).toLowerCase();
      ["oppein", "team", "shop", "agent", "department"].includes(s) ? s === "agent" ? e.orgNo = t.orgNo : e.departmentId = t.id : e.positionId = t.id;
      const o = yield (p = B.value) == null ? void 0 : p.open({
        selectedUser: r.selectedUser,
        extendSearchParams: e
      });
      o && (r.selectedUser = o.selectedUser || []);
    }), ee = (t) => {
      r.selectedUser = r.selectedUser.filter((e) => e.userId !== t);
    }, te = (t) => {
      r.selectedOrg = r.selectedOrg.filter((e) => e.orgId !== t);
    }, se = (t) => {
      const e = t.map((s) => String(s));
      r.selectedOrg = e.map((s) => {
        const o = r.selectedOrg.find((f) => f.orgId === s);
        if (o)
          return o;
        const p = G(r.treeData, s);
        return { orgId: s, orgName: (p == null ? void 0 : p.name) || "" };
      });
    }, S = C(!0), re = (...e) => v(this, [...e], function* (t = {}) {
      var o;
      console.log("userSelectedDialog open params", t), x.value = !0, h.value = (o = t.orgSelectable) != null ? o : !1, r.selectedUser = $(t == null ? void 0 : t.selectedUser) || [], r.selectedOrg = $(t == null ? void 0 : t.selectedOrg) || [], r.treeData = [], yield L();
      const s = yield T();
      S.value = s.orgId !== "1";
    }), z = () => {
      x.value = !1, U("submit", null);
    }, le = () => v(this, null, function* () {
      var s;
      const t = yield T();
      u.value.orgNo = l.isChangeSuccess ? l.orgNo : t.orgNo || "";
      const e = yield (s = B.value) == null ? void 0 : s.open({
        selectedUser: r.selectedUser,
        extendSearchParams: I({}, u.value)
      });
      e && (r.selectedUser = e.selectedUser || []);
    });
    d({
      open: re,
      close: z
    });
    const oe = () => {
      l.isExpanded = !l.isExpanded;
    }, ne = () => v(this, null, function* () {
      if (!l.orgNo) {
        y.warning("商场编码不能为空，请填写");
        return;
      }
      if (S.value && !l.adminPassword) {
        y.warning("admin密码不能为空，请填写");
        return;
      }
      try {
        if (l.loading = !0, S.value) {
          const t = `admin@${l.orgNo}`, e = yield me({
            identityType: "ACCOUNT",
            identifier: t,
            credential: l.adminPassword
          });
          if (!e || !e.status) {
            y.error((e == null ? void 0 : e.message) || "登录失败");
            return;
          }
        }
        yield L(l.orgNo), l.adminPassword = "", l.isChangeSuccess = !0, y.success("切换组织成功");
      } finally {
        l.loading = !1;
      }
    }), ae = () => v(this, null, function* () {
      try {
        r.isLoading = !0;
        const t = yield T();
        yield L(t.orgNo), l.orgNo = "", l.adminPassword = "", l.isExpanded = !1, l.isChangeSuccess = !1, y.success("已返回原组织");
      } finally {
        r.isLoading = !1;
      }
    }), ie = () => {
      x.value = !1;
      const t = {
        selectedUser: r.selectedUser,
        selectedOrg: r.selectedOrg
      };
      console.log("userSelectedDialog confirm", t), U("submit", t);
    };
    return (t, e) => (_(), E(V, null, [
      n("div", {
        ref_key: "userSelectedDialogContainer",
        ref: b
      }, null, 512),
      i(fe, {
        ref_key: "userSelectedByCoditionDialogRef",
        ref: B
      }, null, 512),
      i(c(Ce), {
        bordered: "",
        show: x.value,
        "onUpdate:show": e[4] || (e[4] = (s) => x.value = s),
        "mask-closable": !1,
        "z-index": 9999,
        to: b.value || "body"
      }, {
        default: w(() => [
          i(c(be), {
            show: r.isLoading
          }, {
            default: w(() => [
              i(c(Ne), {
                style: { width: "1300px" },
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: z
              }, {
                header: w(() => [
                  n("div", Ue, [
                    e[9] || (e[9] = n("span", { class: "tw:text-lg tw:font-semibold tw:text-[#303133]" }, "选择适用人员", -1)),
                    n("div", Se, [
                      i(c(m), {
                        type: "primary",
                        size: "small",
                        onClick: oe
                      }, {
                        default: w(() => [
                          k(F(l.isExpanded ? "收起" : "切换组织"), 1)
                        ]),
                        _: 1
                      }),
                      l.isExpanded ? (_(), E(V, { key: 0 }, [
                        e[8] || (e[8] = n("span", { class: "tw:text-[#606266] tw:whitespace-nowrap" }, "商场编码", -1)),
                        i(c(P), {
                          value: l.orgNo,
                          "onUpdate:value": e[0] || (e[0] = (s) => l.orgNo = s),
                          placeholder: "请输入商场编码",
                          size: "small",
                          style: { width: "160px" },
                          clearable: ""
                        }, null, 8, ["value"]),
                        S.value ? (_(), E(V, { key: 0 }, [
                          e[5] || (e[5] = n("span", { class: "tw:text-[#606266] tw:whitespace-nowrap" }, "admin密码", -1)),
                          i(c(P), {
                            value: l.adminPassword,
                            "onUpdate:value": e[1] || (e[1] = (s) => l.adminPassword = s),
                            type: "password",
                            "show-password-on": "click",
                            placeholder: "请输入admin密码",
                            size: "small",
                            style: { width: "160px" },
                            clearable: ""
                          }, null, 8, ["value"])
                        ], 64)) : M("", !0),
                        i(c(m), {
                          type: "primary",
                          size: "small",
                          loading: l.loading,
                          onClick: ne
                        }, {
                          default: w(() => e[6] || (e[6] = [
                            k(" 确定 ", -1)
                          ])),
                          _: 1,
                          __: [6]
                        }, 8, ["loading"]),
                        i(c(m), {
                          type: "warning",
                          size: "small",
                          onClick: ae
                        }, {
                          default: w(() => e[7] || (e[7] = [
                            k(" 返回原组织 ", -1)
                          ])),
                          _: 1,
                          __: [7]
                        })
                      ], 64)) : M("", !0)
                    ])
                  ])
                ]),
                footer: w(() => [
                  n("div", ze, [
                    i(c(m), { onClick: z }, {
                      default: w(() => e[17] || (e[17] = [
                        k("取消", -1)
                      ])),
                      _: 1,
                      __: [17]
                    }),
                    i(c(m), {
                      type: "primary",
                      onClick: ie
                    }, {
                      default: w(() => e[18] || (e[18] = [
                        k("确定", -1)
                      ])),
                      _: 1,
                      __: [18]
                    })
                  ])
                ]),
                default: w(() => [
                  n("div", Oe, [
                    n("div", De, [
                      i(c(ye), {
                        data: r.treeData,
                        "key-field": "id",
                        "label-field": "name",
                        "children-field": "children",
                        "default-expanded-keys": r.defaultExpandedKeys,
                        checkable: h.value,
                        cascade: !1,
                        "checked-keys": H.value,
                        "checkable-option": J,
                        "render-label": Q,
                        "block-line": "",
                        "onUpdate:checkedKeys": se
                      }, null, 8, ["data", "default-expanded-keys", "checkable", "checked-keys"])
                    ]),
                    n("div", Ie, [
                      n("div", Te, [
                        e[11] || (e[11] = n("span", null, "姓名", -1)),
                        i(c(P), {
                          value: u.value.name,
                          "onUpdate:value": e[2] || (e[2] = (s) => u.value.name = s),
                          placeholder: "请输入姓名",
                          clearable: "",
                          style: { width: "160px" }
                        }, null, 8, ["value"]),
                        e[12] || (e[12] = n("span", null, "账号", -1)),
                        i(c(P), {
                          value: u.value.account,
                          "onUpdate:value": e[3] || (e[3] = (s) => u.value.account = s),
                          placeholder: "请输入账号",
                          clearable: "",
                          style: { width: "160px" }
                        }, null, 8, ["value"]),
                        i(c(m), {
                          type: "primary",
                          style: { "margin-left": "20px" },
                          onClick: le
                        }, {
                          default: w(() => e[10] || (e[10] = [
                            k(" 查询 ", -1)
                          ])),
                          _: 1,
                          __: [10]
                        })
                      ]),
                      n("h3", _e, [
                        e[13] || (e[13] = n("span", null, "已选择", -1)),
                        n("span", Ee, F(r.selectedUser.length), 1),
                        e[14] || (e[14] = n("span", null, "人：", -1))
                      ]),
                      i(c(q), {
                        columns: W,
                        data: r.selectedUser,
                        bordered: !0,
                        "max-height": 440,
                        "row-key": (s) => s.userId
                      }, null, 8, ["data", "row-key"])
                    ]),
                    h.value ? (_(), E("div", Pe, [
                      n("h3", Le, [
                        e[15] || (e[15] = n("span", null, "已选择", -1)),
                        n("span", Be, F(r.selectedOrg.length), 1),
                        e[16] || (e[16] = n("span", null, "组织：", -1))
                      ]),
                      i(c(q), {
                        columns: X,
                        data: r.selectedOrg,
                        bordered: !0,
                        "max-height": 440,
                        "row-key": (s) => s.orgId
                      }, null, 8, ["data", "row-key"])
                    ])) : M("", !0)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  tt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/userSelectedDialog/userSelectedDialog.ce.vue.js
// module id = 1341
// module chunks = 67